<template>
    <div class="page white_bg">

        <div style="height: 46px;">
            <header class="pageHeader detailPageHeader paddingH16 paddingV8 white_bg lightGreyBottomBorder" style="line-height: 30px;">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
<!--                            <router-link class="primaryTextColor bold" to="">链接</router-link>-->
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">
            <div class="marginT24 generalPagePaddingH" style="padding-bottom: 34px">
                <form class="form infoForm font14r" action="javascript:;">
                    <div class="form_row clearfix">
                        <div class="fl">
                            <label class="block formLabel">上传头像</label>
                            <div class="font10r" style="color: #B1B4B9">*点击头像框可上传园区头像</div>
                        </div>
                        <div class="fr">
                            <label class="headImageLink block circle size48 hiddenOverflow">
                                <img class="image" :src="dataItem ? dataItem.headImage : ''"
                                     v-show="dataItem && dataItem.headImage" />
                                <i class="icon plusIcon"></i>
                                <input type="file" class="hidden" name="file" @change="onChangeHeadImageFile"/>
                            </label>
                        </div>
                    </div>
                    <div class="form_row">
                        <label class="block formLabel">园区名字</label>
                        <div class="marginT12">
                            <input class="inputbox noOutline font14r" type="text" placeholder="填写真实的园区名字"
                                   v-model="dataItem.name"
                            />
                        </div>
                    </div>
                    <div class="form_row">
                        <label class="block formLabel">园区地址</label>
                        <div class="marginT12">

                            <!-- 省级 -->
                            <select class="selectbox areaSelect" v-model="dataItem.province"
                                    @click="selectedProvince = citiesData[dataItem.province]">
                                <option value="">--请选择--</option>
                                <option v-for="(provinceItem, key) in citiesData" :key="key" :value="key">
                                    {{key}}
                                </option>
                            </select>-

                            <!-- 市级 -->
                            <select class="selectbox areaSelect" v-model="dataItem.city"
                                @click="selectedCity = selectedProvince[dataItem.city]">
                                <option value="">--请选择--</option>
                                <option v-for="(cityItem, key) in selectedProvince ? selectedProvince : {}"
                                    :key="key" :value="key">
                                    {{key}}
                                </option>
                            </select>-

                            <!-- 区/镇/县 -->
                            <select class="selectbox areaSelect" v-model="dataItem.area">
                                <option value="--请选择--"></option>
                                <option v-for="(areaItem, index) in selectedCity ? selectedCity : []" :key="index" :value="areaItem">
                                    {{areaItem}}
                                </option>
                            </select>

<!--                            <input class="inputbox noOutline font14r" type="text" placeholder="填写园区所在真实地址"-->
<!--                                   v-model="dataItem.address"-->
<!--                            />-->
                        </div>
                    </div>
                    <div class="form_row">
                        <label class="block formLabel">联系方式</label>
                        <div class="marginT12">
                            <input class="inputbox noOutline font14r" type="text" placeholder="填写园区的联系方式"
                                   v-model="dataItem.phone"
                            />
                        </div>
                    </div>
                    <div class="form_row">
                        <label class="block formLabel">联系邮箱</label>
                        <div class="marginT12">
                            <input class="inputbox noOutline font14r" type="text" placeholder="填写最常用的邮箱"
                                v-model="dataItem.email"
                            />
                        </div>
                    </div>
                    <div class="form_row">
                        <label class="block formLabel">园区介绍</label>
                        <div class="marginT12">
                            <textarea class="inputbox block noOutline font14r" placeholder="填写对园区的介绍"
                                style="width: 100%; min-height: 44px;" v-model="dataItem.introduce"
                            />
                        </div>
                    </div>

                    <div class="form_row" style="border-bottom: none;">
                        <label class="block formLabel">园区风采</label>
                        <div class="marginT12 imageList clearfix">
                            <a href="javascript:;" class="imageItem" v-for="imageItem in dataItem ? dataItem.imgList : []" :key="imageItem">
                                <img :src="imageItem" class="fullSpace cover"/>
                            </a>
                            <label class="imageItem">
                                <input class="hidden" type="file" name="file" @change="onChangeParkImageFile"/>
                                <i class="icon greyPlusIcon"/>
                            </label>

                        </div>
                    </div>

                    <div style="height: 86px;">
                        <div class="optArea fixedBottom white_bg" style="height: 86px;">
                            <div class="generalPagePaddingH" style="padding-top: 5px;">
                                <button class="button block orangeButton" style="border-radius: 20px;
                                    height: 42px; line-height: 42px;" :disabled="!dataItem || !dataItem.name"
                                    @click="save()">保存设置</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import citiesData from '@data/cities_v2.json'

// api
import fileApi from '@api/file';

// util
import appHelper from '@/util/appHelper';

const config = {
    apiConfig : {
        get : {
            url : 'portal/recruit/park/get'
        },
        update : {
            url : 'portal/recruit/park/update',
            method : 'PUT'
        },
    }
};

export default {
    name: "editMyParkInfo",
    extends : shixunPagePart,
    data () {
        return {
            title : '园区信息',
            apiConfig : config.apiConfig,
            enableDataItem: true,
            autoLoadDataItem: true,
            primaryKey : 'parkId',
            dataItem: {
                headImage: "",
                name: "",
                address: "",
                phone: "",
                email: "",
                introduce: "",
                imgList : []
            },
            citiesData : citiesData,
            selectedProvince : null,
            selectedCity : null
        }
    },
    methods : {
        onChangeHeadImageFile(event) {
            let e = event.currentTarget;
            let file = e.files ? e.files[0] : null;
            if (!file)
            {
                return;
            }

            fileApi.uploadImage(file).then((res) => {

                let result = res.data;
                if (typeof(result) === 'string')
                {
                    result = JSON.parse(result);
                }
                this.dataItem.headImage = result.data;
            }).catch((error) => {
                appHelper.generalAjaxError(error);
            });
        },
        onChangeParkImageFile(event) {
            let e = event.currentTarget;
            let file = e.files ? e.files[0] : null;
            if (!file)
            {
                return;
            }

            fileApi.uploadImage(file).then((res) => {
                let result = res.data;
                if (typeof(result) === 'string')
                {
                    result = JSON.parse(result);
                }
                this.dataItem.imgList.push(result.data);
            }).catch(appHelper.generalAjaxError);
        },

        beforeSubmit(data) {
            data.imgs = JSON.stringify(data.imgList);
            delete data.imgList;
            delete data.jobList;
            delete data.seekerList;
            return data;
        },

        onSubmitSuccess() {
            appHelper.showHint('保存成功！');
        },
        /**
         *
         * @param   {String}    province
         * @returns
         */
        getCityListByProvince(province) {

            for (let key in this.citiesData)
            {
                if(key == province)
                {
                    return this.citiesData[key];
                }
            }
            return [];
        },

        /**
         * @param   {String}    province
         * @param   {String}    city
         * @returns
         */
        getAreaListByProvinceCity(province, city) {

            let provinceItem = province ? this.citiesData[province] : null;
            if (!provinceItem)
            {
                return [];
            }

            for (let key in provinceItem)
            {
                if(key == city)
                {
                    return this.provinceItem[key];
                }
            }
            return [];
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
.infoForm {

    .form_row {
        padding: 20px 0 10px;
        border-bottom: 1px solid #F0F0F0;
    }
    .formLabel {
        color: #8994A9;
        margin-bottom: 12px;
    }
    .headImageLink {
        background: transparent;
        .plusIcon {
            width: 48px;
            height: 48px;
            background-image: url('data:image/png;base64,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');
        }
        .image {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .inputbox {
        border: none;
        background: transparent;
        color: #333333;
        font-size: 100%;
    }
    .imageList {
        .imageItem {
            position: relative;
            float: left;
            width: 84px;
            height: 84px;
            background: #F7F7F7;
            border: 1px solid #DFDFE0;
            border-radius: 4px;
            margin: 0 10px 10px 0;

            .greyPlusIcon {
                position: absolute;
                z-index: 1;
                left: 50%;
                top: 50%;
                margin-left: -17px;
                margin-top: -17px;
                width: 34px;
                height: 34px;
            }
        }

    }
}
.areaSelect {
    width: 64px;
    height: 24px;
    background: #f2f2f2;
    border: 1px solid #f0f0f0;

    border-radius: 2px;
    appearance: none; /* 去掉默认图标 */
    margin: 0 5px;
    text-align: center;
}
</style>
